import { DEFAULT_LOCALE } from '../../config/constants';

/**
 * Creates a date formatter for event dates that displays in a human-readable format
 * with timezone information, respecting the user's locale.
 *
 * Format (en-US): "Tuesday, Dec 31, 2024, 7:00 AM PST"
 * Notes:
 * - Uses abbreviated month and short timezone (e.g., PST, CET)
 * - Other locales will follow their natural formatting conventions
 *
 * @param timezone - The timezone for the event (e.g., "America/Los_Angeles")
 * @param locale - The user's locale (e.g., "en-US", "fr-FR")
 * @param includeTime - When false, omits the time and timezone (e.g., "Tuesday, Dec 31, 2024")
 * @returns Intl.DateTimeFormat instance for formatting event dates
 */

export const createEventDateFormatter = (
  timezone: string = 'UTC',
  locale: string = DEFAULT_LOCALE,
  includeTime: boolean = true
): Intl.DateTimeFormat => {
  const timeOptions: Intl.DateTimeFormatOptions = includeTime
    ? { hour: 'numeric', minute: 'numeric', timeZoneName: 'short' }
    : {};

  return new Intl.DateTimeFormat(locale, {
    ...timeOptions,
    weekday: 'long',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: timezone,
  });
};
